import React from "react"
import styled from "styled-components"

import { Media } from "../common"

import classNames from "classnames"

import { gradientBorder } from "src/utils"

const PostAuthor = ({ author, horizontal }) => {
  return (
    <StyledPostAuthor className={classNames("postAuthor", { horizontal })}>
      <div className="avatarWrap">
        <Media className="avatar" media={{ desktop: author.avatar }} />
      </div>

      <div className="authorWrap">
        <p className="author">{author.fullName}</p>
        {horizontal && <span className="pipe">|</span>}
        <p className="position">{author.position}</p>
      </div>
    </StyledPostAuthor>
  )
}

const StyledPostAuthor = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-gap: var(--sp-8);
  align-items: center;

  .avatarWrap {
    ${gradientBorder({
      background:
        "180deg,rgba(10, 31, 62, 1) 26%,rgba(9, 30, 61, 1) 60.26%,rgba(10, 32, 65, 1) 90%",
      gradient: "180deg,#82b3fc 0%,#9584fb 34.38%,#de90e5 68.75%,#f595b5 100%",
    })};

    border-radius: 50%;
    padding: 3px;
    box-shadow: var(--card-shadow);
    border: 2px solid transparent;

    .avatar {
      width: 50px !important;
      height: 50px !important;
      border-radius: 50%;

      .gatsby-image-wrapper,
      img {
        object-position: center;
        border-radius: 50%;
        width: 100%;
        height: 100%;
      }
    }
  }

  .authorWrap {
    display: grid;
    grid-template-columns: 1fr;

    .author,
    .pipe {
      color: white;
    }

    .author,
    .pipe,
    .position {
      font-size: 1.125rem;
      line-height: 1;
      font-weight: 400;
    }

    .author {
      font-weight: 700;
    }

    .position {
      font-size: 1rem;
      margin-top: 4px;
    }
  }

  &.horizontal {
    .authorWrap {
      justify-content: flex-start;
      align-items: center;
      grid-template-columns: auto auto auto;
      grid-gap: var(--sp-4);
    }
  }
`

export default PostAuthor
